import BaseModel from "../models/baseModel";
import {Hash} from "../interfaces/hashInterfaces";
import {ICapable} from "../interfaces/capableInterfaces";
import Revive from "~/models/revive/revive"

export interface ICanConfigModel {
  displayName: string
}

export default class Can {
  user: ICapable;
  private debug: boolean = false;

  cans: Hash<Hash<Array<Function>>> = {};

  // vue plugin
  install(Vue, options) {
    if (Vue.prototype.$cans) {
      Vue.prototype.$cans.push(this.can.bind(this));
    } else {
      Vue.prototype.$cans = [this.can.bind(this)];
      Vue.prototype.$can = (ability, model, func) => {
        return Vue.prototype.$cans.some(c => c(ability, model, func));
      };
    }
  }

  constructor(user: ICapable) {
    this.user = user;
  }

  iCan(ability: string | Array<string>, model: typeof BaseModel | ICanConfigModel | Array<typeof BaseModel | ICanConfigModel>, func: (...args) => boolean = null) {
    if (ability instanceof Array) {
      for (const a of ability) {
        this.iCan(a, model, func);
      }
      return;
    }
    if (model instanceof Array) {
      for (const m of model) {
        this.iCan(ability, m, func);
      }
      return;
    }
    const modelString = model.displayName;
    ability = <string>ability;

    if (this.cans[modelString] === null || this.cans[modelString] === undefined) {
      this.cans[modelString] = {};
    }
    if (this.cans[modelString][ability] === null || this.cans[modelString][ability] === undefined) {
      this.cans[modelString][ability] = [];
    }
    if (func === null || func === undefined) {
      this.log(`Registering always can for model: ${modelString} and ability ${ability}`);
      this.cans[modelString][ability].push(() => true);
    } else {
      this.log(`Registering func can for model: ${modelString} and ability ${ability}`);
      this.cans[modelString][ability].push(func);
    }
  }

  can(ability: string, model: typeof BaseModel | BaseModel, data: object = {}) {
    let modelString = null;
    let funcArray: Array<Function>;
    let argument: object = null;
    if (!model) {
      this.log(`Returning false for model: ${modelString} and ability ${ability} because model is null`);
      return false;
    } else if (model instanceof BaseModel) {
      modelString = model.generalClassDisplayName || model.displayName;
    } else {
      modelString = model.displayName;
    }
    argument = model;
    if (!this.cans[modelString]) {
      this.log(`Returning false for model: ${modelString} and ability ${ability} because model not found`);
      return false;
    }
    funcArray = this.cans[modelString][ability];
    if (!funcArray) {
      this.log(`Returning false for model: ${modelString} and ability ${ability} because no funcs found`);
      return false;
    }
    for (const func of funcArray) {
      if (func(argument, data)) {
        this.log(`Returning true for model: ${modelString} and ability ${ability} because func passed`);
        return true;
      }
    }
    this.log(`Returning false for model: ${modelString} and ability ${ability} because all funcs checked and no func passed`);
    return false;
  }

  private log(message: string) {
    if (this.debug) {
      console.log(`DEBUG: Can: ${message}`);
    }
  }
}